// config.js

const bizIcon = "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg";
const imageOne = "https://media.istockphoto.com/id/1344824365/photo/aerial-neighborhood-view.jpg?s=612x612&w=0&k=20&c=-0UeGCKBEaAYVbVk2rntz1BZx1Nme9IXzZLXpoclTZ0=";
const imageTwo = "https://media.istockphoto.com/id/1638450793/photo/lakeridge-neighborhood-of-saskatoon.jpg?s=612x612&w=0&k=20&c=sw0_pv9auQ6yeHwu7-MHePXYCoNqy1oeNNSviEI6JHs=";
const imageThree = "https://media.istockphoto.com/id/180713155/photo/townhouses.jpg?s=612x612&w=0&k=20&c=ZJXsFWgO4twf86Gyo5QS5wWYKYCTmZ8mGMOkMz5sOMM=";
const imageFour = "https://media.istockphoto.com/id/843478844/photo/aerial-view-of-american-agricultural-fields.jpg?s=612x612&w=0&k=20&c=RGGYmTG_VNDCIIOD7JaR9QEjwdjPEFhmALMY2yO-3uE=";
const imageFive = "https://media.istockphoto.com/id/1255838957/photo/santa-fe-springs-california.jpg?s=612x612&w=0&k=20&c=D7CndUlXVBA2mK_-Ol1eATXTkEqC1UMaiUSdpUxRzG4=";

const socialMediaLink = 'https://www.lidodreamteam.com/';

export const siteConfig = {
  title: "Michael Mattson | Real Estate",
  metaDescription: "Michael Mattson | Real Estate",
  theme: {
    primaryColor: "blue-500",
    secondaryColor: "gray-200",
    accentColor: "text-blue-500"
  },
  logo: {
    src: bizIcon,
    alt: "Michael Mattson | Real Estate",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Michael Mattson | Real Estate",
    headline: "Your Go-To Realtor in Anaheim, CA",
    address: "East Cerritos Avenue 8A, Anaheim, CA 92806",
    description: 
      "At Michael Mattson | Real Estate, we specialize in turning your dream home into a reality. With a deep understanding of the Anaheim market and a commitment to exceptional service, we guide you through every step of the buying, selling, or investing process. Let us help you find your perfect home today.",
  },
  images: {
    business: {
      src: imageOne,
      alt: "Your Go-To Realtor in Anaheim, CA",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description:
        "With in-depth knowledge of Anaheim's neighborhoods and market conditions, Michael Mattson ensures a seamless real estate experience tailored to your needs.",
    },
    {
      description:
        "Whether you're buying your dream home or selling your current property, Michael provides expert advice and personalized guidance from start to finish.",
    },
    {
      description:
        "Committed to exceeding expectations, Michael Mattson delivers exceptional service, reliability, and results that make your real estate journey stress-free and successful.",
    },
  ],
  services: {
    sectionTitle: "Our Services",
    description: 
      "As your trusted realtor, Michael Mattson | Real Estate is committed to helping you navigate the Anaheim real estate market with ease. Whether you’re buying your first home, upgrading to a larger space, or investing in property, we provide personalized service to ensure your goals are met. With deep market insights and a client-focused approach, we make every transaction seamless and rewarding.",
    callouts: [
      {
        name: 'Single Family Homes',
        description: 
          "Find your perfect family home with Michael Mattson. We specialize in matching buyers with homes that meet their needs and lifestyle.",
        imageSrc: imageTwo,
        imageAlt: 'Beautiful single-family home with a manicured lawn',
      },
      {
        name: 'Condos and Townhouses',
        description: 
          "Explore modern and convenient living options in Anaheim. Let us guide you to the ideal condo or townhouse that fits your budget and taste.",
        imageSrc: imageThree,
        imageAlt: 'Stylish condo with modern architecture',
      },
      {
        name: 'Lots and Land',
        description: 
          "Looking to build your dream home? Michael Mattson can help you find the perfect lot or acreage to bring your vision to life.",
        imageSrc: imageFour,
        imageAlt: 'Expansive lot of land ready for development',
      }
    ]
  },  
  about: {
    sectionTitle: "About Us",
    description: 
      "Michael Mattson brings a wealth of knowledge on Anaheim’s local communities, current market conditions, and the home buying and selling process. Whether you’re purchasing your dream home or selling your current property, Michael is committed to providing exceptional service every step of the way. With deep local expertise and a client-centered approach, he ensures a seamless and rewarding real estate experience tailored to your unique needs.",
    image: {
      src: imageFive,
      alt: "Michael Mattson discussing real estate opportunities with a client",
      width: 2432,
      height: 1442
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "East Cerritos Avenue 8A, Anaheim, CA 92806",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3313.948430067216!2d-117.88756!3d33.81132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcd7f1234567%3A0xabcdef123456789!2s2051%20E%20Cerritos%20Ave%20Suite%208A%2C%20Anaheim%2C%20CA%2092806%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: "https://maps.apple.com/?address=2051%20E%20Cerritos%20Ave%20Suite%208A,%20Anaheim,%20CA%2092806&ll=33.81132,-117.88756&q=2051%20E%20Cerritos%20Ave%20Suite%208A"
      },
      { 
        name: 'Bing Maps', 
        url: "https://www.bing.com/maps?q=2051+E+Cerritos+Ave+Suite+8A,+Anaheim,+CA+92806&form=HDRSC6&sp=1&pq=2051+e+cerritos+ave&sc=0-0&qs=n&sk=&cvid=ABCDEF1234567890"
      },
      { 
        name: 'Google Earth', 
        url: "https://www.google.com/maps/place/2051+E+Cerritos+Ave+Suite+8A,+Anaheim,+CA+92806,+USA/@33.81132,-117.88756,17z"
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/2435+W+Highland+Ave,+Apopka,+FL+32703,+USA/@28.676937,-81.517655,17z' 
      }
    ]
  },  
  contact: {
    sectionTitle: "Schedule a Free Consultation for Your Real Estate Needs",
    description: "Ready to buy, sell, or invest in real estate? Contact Michael Mattson today to schedule a free consultation. With expert knowledge of the Anaheim market and a commitment to personalized service, Michael is here to guide you every step of the way in achieving your real estate goals.",
    socialLinks: {
      facebook: socialMediaLink,
      instagram: socialMediaLink,
      twitter: socialMediaLink,
      youtube: socialMediaLink,
      tiktok: socialMediaLink
    },
    contactNumbers: ["949-697-1809"],
    logo: bizIcon,
    emailRecipient: "mattsonrealestate@yahoo.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
